import type {
  SiteGroupAttachRolesApiData,
  SiteGroupAttachRolesApiResponses,
  SiteGroupCreateApiData,
  SiteGroupCreateApiResponses,
  SiteGroupDetachRolesApiData,
  SiteGroupDetachRolesApiResponses,
  SiteGroupGetApiData,
  SiteGroupGetApiResponses,
  SiteGroupListApiData,
  SiteGroupListApiResponses,
  SiteGroupPatchApiData,
  SiteGroupPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getSiteGroupUrls = {
  getPaginatedSiteGroups: dataEndpoint<SiteGroupListApiData, SiteGroupListApiResponses>({
    getUrl: (queryParams) => apiUrl('site-groups/', queryParams)
  }),
  getSiteGroup: dataEndpoint<SiteGroupGetApiData, SiteGroupGetApiResponses>({
    getUrl: ({ siteGroupId }) => apiUrl(`site-groups/${siteGroupId}/`)
  }),
  postSiteGroup: responseEndpoint<SiteGroupCreateApiData, SiteGroupCreateApiResponses>({
    getUrl: () => apiUrl('site-groups/'),
    getBody: (data) => data
  }),
  patchSiteGroup: responseEndpoint<SiteGroupPatchApiData, SiteGroupPatchApiResponses>({
    getUrl: ({ siteGroupId }) => apiUrl(`site-groups/${siteGroupId}/`),
    getBody: ({ siteGroupId: _, ...body }) => body
  }),
  postSiteGroupAttachRoles: responseEndpoint<SiteGroupAttachRolesApiData, SiteGroupAttachRolesApiResponses>({
    getUrl: ({ siteGroupId }) => apiUrl(`site-groups/${siteGroupId}/attach/`),
    getBody: ({ siteGroupId: _, ...body }) => body
  }),
  postSiteGroupDetachRoles: responseEndpoint<SiteGroupDetachRolesApiData, SiteGroupDetachRolesApiResponses>({
    getUrl: ({ siteGroupId }) => apiUrl(`site-groups/${siteGroupId}/detach/`),
    getBody: ({ siteGroupId: _, ...body }) => body
  })
};
